import { render, staticRenderFns } from "./WAATCA.vue?vue&type=template&id=29843a0d&"
import script from "./WAATCA.vue?vue&type=script&lang=js&"
export * from "./WAATCA.vue?vue&type=script&lang=js&"
import style0 from "./WAATCA.vue?vue&type=style&index=0&id=29843a0d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports